import { createSlice } from '@reduxjs/toolkit'
import { getGameSetting, roundVerifyHash } from 'redux-store/thunk/gameSettings.thunk'
import { generateServerSeed } from 'redux-store/thunk/user.thunk'
import { generateClientSeed } from 'utils/common-functions/index'

// can assign the function to the state directly as it is executed at memory allocation phase

const initialState = {
  systemGameData: null,
  allCurrencies: [],
  gameSettings: [],
  gameSettingLoader: false,
  clientSeed: null,
  serverSeedHash: '',
  gameMusic: false,
  gameSound: false,
  roundHashDetails: null,
  isFiatCurrency: true,
  currencyPrecision: 2
}

const setClientSeed = () => {

}

const {
  actions: {
    setAllCurrency,
    setGameSettings,
    setGameSettingLoader,
    setNewClientSeed,
    setServerSeedHash,
    setGameMusic,
    updateGameSetting,
    setGameSound,
    resetGameHashDetails,
    setGameCurrencyInfo
  },
  reducer
} = createSlice({
  name: 'gameSetting',
  initialState,
  reducers: {
    setAllCurrency: (state, action) => {
      const _mapObj = {}
      if (action.payload && action.payload?.length > 0) {
        action.payload.forEach(currency => {
          _mapObj[currency?.id] = currency?.code
        })
      }
      return ({
        ...state,
        allCurrencies: action.payload,
        currencyObj: _mapObj
      })
    },
    setGameSettings: (state, action) => ({
      ...state,
      gameSettings: action.payload
    }),
    setGameSettingLoader: (state, action) => ({
      ...state,
      setGameSettingLoader: action.payload
    }),
    setNewClientSeed: (state, action) => ({
      ...state,
      clientSeed: action.payload
    }),
    setServerSeedHash: (state, action) => ({
      ...state,
      serverSeedHash: action.payload
    }),
    setGameMusic: (state, action) => ({
      ...state,
      gameMusic: !state.gameMusic
    }),
    setGameSound: (state, action) => ({
      ...state,
      gameSound: !state.gameSound
    }),
    updateGameSetting: (state, action) => {
      return {
        ...state,
        systemGameData: action.payload
      }
    },
    resetGameHashDetails: (state, action) => ({
      ...state,
      roundHashDetails: null
    }),
    setGameCurrencyInfo: (state, action) => ({
      ...state,
      ...action.payload
    })
  },
  extraReducers: (builder) => {
    builder
      .addCase(getGameSetting.fulfilled, (state, action) => {
        return {
          ...state,
          systemGameData: action.payload,
          gameSettingLoader: false,
          clientSeed: generateClientSeed()
        }
      })
      .addCase(generateServerSeed.fulfilled, (state, action) => {
        return {
          ...state,
          serverSeedHash: action.payload?.serverSeedHash ?? ''
        }
      })
      .addCase(generateServerSeed.rejected, (state, action) => {
        return {
          ...state
        }
      })
      .addCase(roundVerifyHash.fulfilled, (state, action) => {
        return {
          ...state,
          roundHashDetails: action.payload
        }
      })
  }
})

export default reducer
export {
  setAllCurrency,
  setGameSettings,
  setGameSettingLoader,
  setNewClientSeed,
  setGameMusic,
  setServerSeedHash,
  updateGameSetting,
  setGameSound,
  setClientSeed,
  resetGameHashDetails,
  setGameCurrencyInfo
}
